/**
 * Test ids for the route section of the create-shipment form.
 *
 * The suffix encodes the stop's *position* rather than its index, because the e2e suite addresses
 * the first and last stop by name (they are the mandatory loading / unloading stops) and the
 * optional ones in between by ordinal.
 */
export const getRouteTestIds = (locIndex: number, locCount: number) => {
  const positionSuffix =
    locIndex === 0
      ? 'First'
      : locIndex === locCount - 1
        ? 'Last'
        : `Mid${locIndex}`;

  const locationPrefix = `location${positionSuffix}`;

  return {
    locationSelect: `${locationPrefix}-locationName`,
    locationTimezone: `${locationPrefix}-timezone`,
    locationSelected: `${locationPrefix}-address`,
    locationMainContact: `${locationPrefix}-mainContact`,
    locationMainContactDetail: `${locationPrefix}-mainContactDetail`,
    locationNotifyOfTransport: `${locationPrefix}-notifyOfTransport`,
    locationLoadingReference: `locationLoadingReference${positionSuffix}`,
    locationTimeslot: `${locationPrefix}-timeslotSelect`,
    locationLoading: `locationLoading${positionSuffix}`,
    locationUnloading: `locationUnloading${positionSuffix}`,
  };
};

export type RouteTestIds = ReturnType<typeof getRouteTestIds>;
